import { render } from "./BlankLayout.vue?vue&type=template&id=527845ac&scoped=true&ts=true"
import script from "./BlankLayout.vue?vue&type=script&lang=ts"
export * from "./BlankLayout.vue?vue&type=script&lang=ts"

import "./BlankLayout.vue?vue&type=style&index=0&id=527845ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527845ac"]])

export default __exports__